import { type Trello } from "../types/trello"
import { getImportModal } from "../config"

export async function getOnEnable(t: Trello.PowerUp.IFrame): Promise<void> {
  return t.modal(getImportModal(t))
}
